import { render, staticRenderFns } from "./czrz.vue?vue&type=template&id=bbad0a18&scoped=true&"
import script from "./czrz.vue?vue&type=script&lang=js&"
export * from "./czrz.vue?vue&type=script&lang=js&"
import style0 from "./czrz.vue?vue&type=style&index=0&id=bbad0a18&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbad0a18",
  null
  
)

export default component.exports